module.exports = __webpack_public_path__ + "img/finger@2x.a55a5070.png";